<template>
  <div style="margin-top:10px;">
    <el-row :gutter="20">
      <el-col :md="{span:18, offset: 3}">
          <h1 style="margin-top:unset;">Process Time Analytic Chart</h1>
          <el-card shadow="never">
            <el-row type="flex" justify="end" align="middle" :gutter="2">
              <el-col :span="2">
                <span>
                  <b>PERIOD :</b>
                </span>
              </el-col>
              <el-col :span="6">
                <el-input-number
                  v-model="period"
                  :step="5"
                  :min="30"
                  :max="120"
                  controls-position="right"
                  size="medium"
                ></el-input-number>
              </el-col>
              <el-col :span="2">
                <el-button type="info" size="medium" @click="changePeriod ()">set</el-button>
              </el-col>
            </el-row>
            <div v-loading="loadingChart">
              <timerChart :chart-data="datacollection" :options="options" :height="400"></timerChart>
            </div>
          </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import timerChart from '@/components/Dashboard/TimerChart.vue'
export default {
    name: 'DashboardTimerChart',
    components: { timerChart },
    data () {
        return {
            loadingChart: null,
            period: 30,
            datacollection: {},
            options: {
                responsive: true,
                maintainAspectRatio: false,
                showLines: false,
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true
                            }
                        }
                    ]
                }
            }
        }
    },
    mounted () {
        this.fillData()
    },
    methods: {
        async fillData () {
            this.loadingChart = true
            let param = {
                period: this.period
            }
            try {
                let res = await fgApi.dashboard.getTimerData(param)
                console.log('res: ', res)
                console.log('res data: ', res.data)
                if (res.success) {
                    let myDataset = []
                    for (let dataLabel in res.data) {
                        console.log('dataLabel', dataLabel)
                        if (dataLabel === 'orderList') {
                            myDataset.push({
                                label: 'searchOrder',
                                backgroundColor: '#2ECC71  ',
                                data: Object.values(res.data[dataLabel])
                            })
                        } else if (dataLabel === 'loadingScreen') {
                            myDataset.push({
                                label: dataLabel,
                                backgroundColor: '#3498DB',
                                data: Object.values(res.data[dataLabel])
                            })
                        } else if (dataLabel === 'createOrder') {
                            myDataset.push({
                                label: dataLabel,
                                backgroundColor: '#E74C3C',
                                data: Object.values(res.data[dataLabel])
                            })
                        } else if (dataLabel === 'updateOrder') {
                            myDataset.push({
                                label: dataLabel,
                                backgroundColor: '#F4D03F',
                                data: Object.values(res.data[dataLabel])
                            })
                        }
                    }
                    console.log('myDataset :', myDataset)
                    this.datacollection = {
                        labels: Object.keys(res.data.createOrder),
                        datasets: myDataset
                    }
                }
            } catch (error) {
                this.$notify.error({
                    title: 'Error',
                    message: error
                })
            }
            this.loadingChart = false
        },
        changePeriod () {
            console.log('period', this.period)
            if (this.period == null) {
                this.period = 30
            }
            this.fillData()
        }
    }
}
</script>
